/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorpublishing2Inputs */

const en_menueditorpublishing2 = /** @type {(inputs: Menueditorpublishing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing…`)
};

const de_menueditorpublishing2 = /** @type {(inputs: Menueditorpublishing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird veröffentlicht …`)
};

/**
* | output |
* | --- |
* | "Publishing…" |
*
* @param {Menueditorpublishing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorpublishing2 = /** @type {((inputs?: Menueditorpublishing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorpublishing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorpublishing2(inputs)
	return de_menueditorpublishing2(inputs)
});
export { menueditorpublishing2 as "menuEditorPublishing" }